import { isEmpty } from 'lodash';
import { toast } from 'react-toastify';
import { Component, Fragment } from 'react';
//constants
import { ACADEMIC_VIEW_TYPE,
    CENTRAL_TIMETABLER_VIEW_TYPE, FACILITIES_VIEW_TYPE, INSTRUCTOR_TIMETABLE, NEXT_WEEK, PREV_WEEK, ROOM_TIMETABLE, SET_TIMETABLE } from '../../constants';
//models
import Config from '../../models/config';
//apis
import TimetableApi from '../../api/timetable/timetable.api';
//services
import { exportSSRS } from '../../services/timetable/ssrsReportService';
import { ExportExcelService } from '../../services/timetable/exportExcelService';
//comps
import Base from './base';

export const withAppBarContext = (Element) => {
    // eslint-disable-next-line react/display-name
    return forwardRef((props, ref) => {
        return <AppBarState.Consumer>{(context) => <Element appBarState={context} {...props} ref={ref} />}</AppBarState.Consumer>;
    });
};

//TODO: State Management
class Timetable extends Component {
    _timetableApi = new TimetableApi();
    #excelService;

    _isMounted = false;

    constructor(props) {
        super(props);

        this.state = {
            timetables: [],
            conflicts: [],
            config: {},
            title: '', //default title
            week: (props.termCode.endsWith('B') ? 0 : 1), //default week - use week 1 for term-B, default of week 2 otherwise
            settings: props.settings,
            timetableType: props.type,
            ignoreRoomConflicts: false,
            classData: null,
            weekTitle: '',
        };

        this.#excelService = new ExportExcelService();
    }

    async componentDidMount() {
        this._isMounted = true;

        const { settings, timetableType, week } = this.state;

        if (this._isMounted && !isEmpty(settings) && timetableType !== '') {
            await this.handleTimetableChange(timetableType, week);
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidUpdate(prevProps) {
        const { shouldUpdate } = this.props;
        const { week, timetableType } = this.state;

        if (shouldUpdate !== prevProps.shouldUpdate) {
            await this.handleTimetableChange(timetableType, week);
        }
    }

    getSetTimetable = async (settings, week) => {
        const { schoolID, termSchoolID, termCampusId, accountID, onClickThrough, viewType } = this.props;

        const {
            timetableType,
            settings: { id },
        } = this.state;

        if (settings.id !== this.props.settings.id) {
            onClickThrough({
                remove: {
                    timetableType,
                    id,
                },
                add: {
                    timetableType: SET_TIMETABLE,
                    id: settings.id,
                    setCode: settings.setCode,
                    departmentCode: settings.departmentCode,
                },
            });
        }

        let { timetables, conflicts, config } = await this._timetableApi.GetBySet({
            schoolID: schoolID,
            setID: settings.id,
            termSchoolID: viewType === ACADEMIC_VIEW_TYPE ? termSchoolID : null,
            termCampusId: viewType === FACILITIES_VIEW_TYPE || viewType === CENTRAL_TIMETABLER_VIEW_TYPE ? termCampusId : null,
            week: week,
            accountID: accountID,
        });

        if (timetables.length === 0) {
            toast.info(`There is no data for ${settings.setCode}`);
        }

        const title = this.getSetTitle(settings);
        const weekTitle = this.getWeek(week);

        this.setState({
            timetables,
            conflicts,
            config,
            title,
            week,
            settings,
            timetableType: SET_TIMETABLE,
            weekTitle,
        });
    };

    /*
     * Get an Instructor's timetable for a single week
     */
    getInstructorTimetable = async (settings, week) => {
        const { schoolID, termSchoolID, termCampusId, accountID, onClickThrough, viewType } = this.props;
        const {
            timetableType,
            settings: { id, name },
        } = this.state;

        if (settings.id !== this.props.settings.id) {
            onClickThrough({
                remove: {
                    timetableType,
                    id,
                },
                add: {
                    timetableType: INSTRUCTOR_TIMETABLE,
                    id: settings.id,
                    name: settings.name,
                },
            });
        }

        const { timetables, conflicts, config } = await this._timetableApi.GetByInstructor({
            schoolID: schoolID,
            instructorID: settings.id,
            termSchoolID: viewType === ACADEMIC_VIEW_TYPE ? termSchoolID : null,
            termCampusId: viewType === FACILITIES_VIEW_TYPE || viewType === CENTRAL_TIMETABLER_VIEW_TYPE ? termCampusId : null,
            week: week,
            accountID: accountID,
        });

        const title = this.getInstructorTitle(settings);
        const weekTitle = this.getWeek(week);

        this.setState({
            timetables,
            conflicts,
            config,
            title,
            week,
            settings,
            timetableType: INSTRUCTOR_TIMETABLE,
            weekTitle,
        });
    };

    //Not setup for sandbox
    getRoomTimetable = async (settings, week) => {
        const { termSchoolID, termCampusId, accountID, onClickThrough, viewType } = this.props;

        const {
            timetableType,
            settings: { id },
        } = this.state;

        if (settings.id !== this.props.settings.id) {
            onClickThrough({
                remove: {
                    timetableType,
                    id,
                },
                add: {
                    timetableType: ROOM_TIMETABLE,
                    id: settings.id,
                    roomNumber: settings.roomNumber,
                    buildingCode: settings.buildingCode,
                },
            });
        }

        const { timetables, conflicts, config } = await this._timetableApi.GetByRoom({
            roomID: settings.id,
            termSchoolID: viewType === ACADEMIC_VIEW_TYPE ? termSchoolID : null,
            termCampusId: viewType === FACILITIES_VIEW_TYPE || viewType === CENTRAL_TIMETABLER_VIEW_TYPE ? termCampusId : null,
            week: week,
            accountID: accountID,
        });

        const title = this.getRoomTitle(settings);
        const weekTitle = this.getWeek(week);

        this.setState({
            timetables,
            conflicts,
            config,
            title,
            week,
            settings,
            timetableType: ROOM_TIMETABLE,
            weekTitle,
        });
    };

    getSetTitle = (settings) => {
        return `${settings.setCode}`;
    };

    getInstructorTitle = (settings) => {
        return `${settings.name} `;
    };

    getRoomTitle = (settings) => {
        return `${settings.buildingCode} - ${settings.roomNumber} `;
    };

    getWeek = (week) => {
        return `Week: ${week + 1} `;
    };

    /*
     * Increment or Decrement week
     */
    handleWeekChange = async (name) => {
        let week = this.state.week;

        const timetableType = this.state.timetableType;

        if (name === PREV_WEEK) {
            --week;

            if (week < 0) return;

            await this.handleTimetableChange(timetableType, week);
        } else if (name === NEXT_WEEK) {
            //FIXME: check against term end
            ++week;
            await this.handleTimetableChange(timetableType, week);
        }
    };

    handleTimetableChange = async (timetableType, week) => {
        const { settings } = this.state;
        switch (timetableType) {
            case SET_TIMETABLE:
                await this.getSetTimetable(settings, week);
                break;
            case INSTRUCTOR_TIMETABLE:
                await this.getInstructorTimetable(settings, week);
                break;
            case ROOM_TIMETABLE:
                await this.getRoomTimetable(settings, week);
                break;
            default:
                break;
        }
    };

    handleExcelExport = async () => {
        const { termCode } = this.props;
        const { termSchoolID } = this.props;
        const { timetableType, settings, week } = this.state;

        await this.#excelService.downloadExcelSheet(timetableType, termCode, termSchoolID, week, settings);
    };

    handleSSRSExport = async () => {
        const { timetableType, settings, week } = this.state;
        const { termSchoolID } = this.props;

        await exportSSRS(timetableType, settings.id, termSchoolID, week);
    };

    render() {
        let { timetables, config, conflicts, title, week, weekTitle, timetableType, settings, ignoreRoomConflicts, classData } = this.state;

        const { termSchoolID, schoolID, termStartDate, termEndDate, termSelected } = this.props;

        //render empty timetable
        //FIXME: if not set, app crashes because of infinite loop in Base.jsx
        if (isEmpty(config) && title === '') {
            config = new Config();
            title = 'Title';
        }

        return (
            <Fragment>
                <Base
                    key={settings.id}
                    timetables={timetables}
                    conflicts={conflicts}
                    config={config}
                    getInstructorTimetable={this.getInstructorTimetable}
                    getSetTimetable={this.getSetTimetable}
                    getRoomTimetable={this.getRoomTimetable}
                    handleWeekChange={this.handleWeekChange}
                    title={title}
                    week={week}
                    weekTitle={weekTitle}
                    timetableType={timetableType}
                    handleExcelExport={this.handleExcelExport}
                    printSSRSReport={this.handleSSRSExport}
                    timetableID={settings.id}
                    settings={settings}
                    termSelected={termSelected}
                />
            </Fragment>
        );
    }
}

export default Timetable;
